import React from "react";
import moment from "moment-timezone";

class Clock extends React.Component {
	constructor(props) {
		super(props);
		const currentMoment = (this.props.spooftime) ? moment(this.props.spooftime) : moment();
		this.state = {
			currentTime: currentMoment.tz("America/Los_Angeles").format("h:mm:ss a")
		};
	}

	componentDidMount() {
		this.clockInterval = window.setInterval(
			() => {
				this.updateTime();
			},
			1000
		);
	}

	componentWillUnmount() {
		clearInterval(this.clockInterval);
	}

	updateTime() {
		const currentMoment = (this.props.spooftime) ? moment(this.props.spooftime) : moment();

		this.setState({ currentTime: currentMoment.tz("America/Los_Angeles").format("h:mm:ss a") });
	}

	render() {
		return <span>{this.state.currentTime}</span>;
	}
}

export default Clock;



// WEBPACK FOOTER //
// ./src/components/Clock.js